import React from 'react'
import { InspirationUniverseContext } from 'app/React/InspirationUniverse/InspirationUniverseContainer'
import Product from 'app/React/InspirationUniverse/Product'
import useProducts from 'app/React/InspirationUniverse/useProducts'
import Pagination from 'app/React/InspirationUniverse/Pagination'
import classNames from 'classnames'
import { useFirstRender } from 'app/React/InspirationUniverse/useFirstRender'

export default function Products () {

  const { noProductsText, products, currentPage, setCurrentPage, totalPages, uuid, isLoading, setContainerRef, hasFetched } = React.useContext(InspirationUniverseContext)
  const { fetchProducts } = useProducts()

  const containerRef = React.useRef(null)

  React.useEffect(() => {
    fetchProducts()
  }, [currentPage, uuid])

  React.useEffect(() => {
    setContainerRef(containerRef)
  }, [])

  if (!hasFetched) {
    return null
  }

  if (products.length === 0) {
    return <p className="mtt-iu-no-products page_container">{noProductsText}</p>
  }

  return (
    <section
      className={classNames("mtt-iu-products", {
        "mtt-iu-products--loading": isLoading
      })}
      ref={containerRef}
    >
      {products.map((product, index) => <Product key={product.id} index={index} product={product}/>)}
      <Pagination
        onPageChange={(page) => setCurrentPage(page)}
        activePage={currentPage}
        totalPages={totalPages}
      />
    </section>
  )
}
